'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('@brandwatch/axiom-materials/dist/colors');

var _ = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var productColors = Object.keys(_.userDefinedGraphColors);

exports.default = function (string) {
  var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : productColors;
  return colors[string.split('').reduce(function (acc, val) {
    return acc + val.charCodeAt();
  }, 0) % (colors.length - 1)];
};